import http from '../http'
import {USER_URL, USER_LIST_URL, AUTH_URL_MAGIC_LINK} from '@/services/endpoints'

export function getUser() {
  return http.request({
    url: USER_URL,
    method: 'get'
  })
}

export function updateUser(id, data) {
  return http.request({
    url: USER_URL + '/' + id,
    method: 'put',
    data: data
  })
}
export  function resendTokenToUser(id) {
  return http.request({
    url: USER_URL + '/' + id+'/reset',
    method: 'put',
  })
}
export function  getUserList(postData) {
  return http.request({
    url:USER_LIST_URL,
    method:'post',
    data:postData
  })
}
export function createUser(postData){
  return http.request({
    url:USER_URL,
    method:'post',
    data:postData
  })
}
export function deleteUser(id, data) {
  return http.request({
    url: USER_URL + '/' + id,
    method: 'delete',
    data: data
  })
}
export function getUserWithMagicLink(token, params) {
  return http.request({
    url:AUTH_URL_MAGIC_LINK+'/'+token,
    method:'GET',
    params

  })
}
export function enableUser(id,postData){
  return http.request({
    url: USER_URL+'/enable/'+id,
    method: 'POST',
    data: postData
  })
}
export function getPermissions() {
  return http.request({
    url: USER_URL + '/permission',
    method: 'get'
  })
}
export function resetPassword(postData) {
  return http.request({
    url: '/api/reset-password',
    method: 'PUT',
    data: postData
  })
}
